import React from 'react';
import FontAwesomeIcon from '../../Icon';
import Attachment from '../../Attachment';
import { useSelector } from 'react-redux';
import TextareaAutosize from 'react-textarea-autosize';
import './send-message-box.scss';

const SendMessageBox = ({
  message,
  onSendMessage,
  onSetMessage,
  onSetAttachments,
  canSend,
}) => {
  const { user } = useSelector((state: any) => state.auth);

  if (user.roles[0].role.name === 'Realtor') {
    return null;
  }

  return (
    <div className="send-message-box">
      <div className="composer">
        <div className="attach-button">
          <Attachment
            icon={true}
            onSelect={(file) => onSetAttachments(file)}
            files={[]}
            clearFiles={() => onSetAttachments([])}
          />
        </div>
        <TextareaAutosize
          className="message-input"
          minRows={1}
          maxRows={6}
          placeholder="Type a message..."
          value={message}
          onChange={(ev) => onSetMessage(ev.target.value)}
        />
        <div
          className={canSend ? 'send-button' : 'send-button disabled'}
          onClick={canSend ? onSendMessage : undefined}
        >
          <FontAwesomeIcon glyph="paper-plane" weight="light" size="small" />
        </div>
      </div>
    </div>
  );
};

export default SendMessageBox;